(function () {
  'use strict';

  function filterDropdown(FilterDropdownService, $location, FilterService, $filter, $timeout, NetworkListService, $q, NetworkListPaging, TenantListService) {
    return {
      restrict: 'EA',
      scope: {
        alternativeUI: '=alternative',
        filtersList: '=filtersList',
        pagingObject: '=pagingObject',
        requestType: '=requestType',
        presetFilters: '=presetFilters',
        forceFilter: '=forceFilter',
        resetFilters: '=resetFilters',
        getListPaged: '&getListPaged'
      },
      templateUrl: 'app/directives/filterDirectives/filterDropdownDirective/filter-dropdown.template.html',
      link: function (scope, element, attrs) {

        var thisSubmenu = '';
        scope.selectedFilters = [];
        scope.filterModel = null;
        scope.sliders = {};
        scope.inputRangeModel = {};
        scope.searchPattern = { string: '' };
        scope.filtersListOriginal = angular.copy(scope.filtersList);

        //*****************//
        // Setting the parameters on the pagingObject
        // ------------------
        // Resets pagingCriteria and then add the correct filter values to the pagingCriteria
        // Calling scope.getListPaged() on the parent controller
        //*****************//
        function setFiltersOnPagingObject(queryParamFilters, page) {
          if (queryParamFilters.networks) {
            queryParamFilters.networks = decodeURIComponent(queryParamFilters.networks)
          }

          clearFiltersPagingCriteria();

          for (var key in queryParamFilters) {
            scope.pagingObject.pagingCriteria[key] = queryParamFilters[key];
          }

          scope.pagingObject.pagingCriteria.page = page;
          scope.getListPaged();
        }

        function clearFiltersPagingCriteria() {
          for (var i = 0; i < scope.filtersListOriginal.length; i++) {
            var key = scope.filtersListOriginal[i].parameter;
            if (scope.filtersListOriginal[i].type === 'range' || scope.filtersListOriginal[i].type === 'range-date') {
              var wsRange = scope.filtersListOriginal[i].sharedKey;
              var rangeFrom = scope.filtersListOriginal[i][wsRange].keys[0].key;
              var rangeTo = scope.filtersListOriginal[i][wsRange].keys[1].key;
              scope.pagingObject.pagingCriteria[rangeFrom] = null;
              scope.pagingObject.pagingCriteria[rangeTo] = null;
            } else {
              scope.pagingObject.pagingCriteria[key] = null;
            }
          }
        }

        //*****************//
        // Updating the selectedFilters and pass the result to the pagingObject
        // -----------------
        // This evaluate scope.filterModel, to determine addTheFilter() or removeTheFilter
        // Passing SelectedFilters to pagingObject as parameters
        // Save updated scope.filterModel in localStorage
        //*****************//
        scope.updateSelectedFilters = function (init) {

          for (var key in scope.filterModel) {
            var thisFilter = scope.filterModel[key];
            if (thisFilter.state === null) {
              if (thisFilter.key === 'inUse') {
                removeTheFilter(key)
                addTheFilter(key);
              } else {
                removeTheFilter(key)
              }
            } else if (thisFilter.state === true) {
              if (thisFilter.type === 'checkbox' && !hasTheFilter(key)) {
                addTheFilter(key);
              }

              if (thisFilter.type === 'flat_list' && !hasTheFilter(key)) {
                addTheFilter(key);
              }

              if (thisFilter.type === 'pagination' && !hasTheFilter(key)) {
                addTheFilter(key);
              }

              if (thisFilter.type === 'radio') {
                removeTheFilter(key);
                addTheFilter(key);
              }

            } else if (thisFilter.state === false) {
              if (thisFilter.type === 'checkbox' && hasTheFilter(key)) {
                removeTheFilter(key);
              }

              if (thisFilter.type === 'flat_list' && hasTheFilter(key)) {
                removeTheFilter(key);
              }

              if (thisFilter.type === 'pagination' && hasTheFilter(key)) {
                removeTheFilter(key);
              }

              if (thisFilter.type === 'radio') {
                removeTheFilter(key);
                addTheFilter(key);
              }

            } else if (thisFilter.type === 'range' || thisFilter.type === 'range-input' || thisFilter.type === 'range-date') {
              if (!hasTheFilter(key) && isNotDefaultValue(thisFilter)) {
                addTheFilter(key);
              } else if (hasTheFilter(key) && isNotDefaultValue(thisFilter)) {
                removeTheFilter(key);
                addTheFilter(key);
              } else {
                removeTheFilter(key);
              }
            } else if (thisFilter.type === 'radio') {
              removeTheFilter(key);
              addTheFilter(key);
            }
          }

          if (!init) {
            FilterDropdownService.setFiltersInStorage($location.$$path, scope.filterModel);
            setFiltersOnPagingObject(FilterService.filterList(scope.selectedFilters, scope.requestType), 0);
          } else {
            setFiltersOnPagingObject(FilterService.filterList(scope.selectedFilters, scope.requestType), scope.pagingObject.pagingCriteria.page);
          }
        };

        function hasTheFilter(actualKey) {
          return !!scope.selectedFilters.findElement({ key: actualKey });
        }

        function isNotDefaultValue(filterValues) {
          return !filterValues.pristine;
        }

        //*****************//
        // ADD & Remove filters, called from the updateFilters method
        // -----------------
        // Pushes or splices the original filterList object to/from scope.selectedFilters
        // setValuesOnFilterObject() explicit maps the desired ranges to a copy of filterObject, before returning it.
        //*****************//
        function addTheFilter(key) {
          var filter = [];
          scope.filtersListOriginal.forEach(function (filterObject) {
            if ((filterObject.type === 'range' || filterObject.type === 'range-input' || filterObject.type === 'range-date') && filterObject.sharedKey === key) {
              filter.push(setValuesOnFilterObject(filterObject[filterObject.sharedKey]));
            } else if (filterObject.type === 'checkbox' || filterObject.type === 'radio' || filterObject.type === 'flat_list') {
              filter = filter.concat(filterObject.values.filter(function (instance) {
                if (filterObject.type === 'radio') {
                  if (instance.state === scope.filterModel[key].state) {
                    return instance.key === key;
                  }
                } else {
                  return instance.key === key;
                }
              }));
            }
          });


          for (var modelKey in scope.filterModel) {
            var filterObject = scope.filterModel[modelKey];
            if (filterObject.state && filterObject.type === 'pagination') {
              if (!hasTheFilter(filterObject.key)) {
                filter.push(filterObject)
              }
            }
          }
          if (filter[0]) {
            scope.selectedFilters.push(filter[0]);
          }
        }

        function removeTheFilter(key) {
          var index = 0;
          scope.selectedFilters.forEach(function (filter) {
            if (filter.key === key) {
              scope.selectedFilters.splice(index, 1);
            }
            index++;
          });
        }

        function setValuesOnFilterObject(originalFilterObject) {
          var filterObject = angular.copy(originalFilterObject);
          if (filterObject.type === 'range') {
            filterObject.keys[0].count = scope.sliders[filterObject.key].minValue;
            filterObject.keys[1].count = scope.sliders[filterObject.key].maxValue;
          } else if (filterObject.type === 'range-input' || filterObject.type === 'range-date') {
            filterObject.keys[0].count = scope.filterModel[filterObject.key].range[0];
            filterObject.keys[1].count = scope.filterModel[filterObject.key].range[1];
          }
          return filterObject;
        }

        //*****************//
        // Clear 1 or clear ALL filters (these are called from the DOM)
        //*****************//
        scope.removeFilterFromModel = function (filter, update) {
          if (scope.filterModel[filter].type === 'range' || scope.filterModel[filter].type === 'range-input') {
            scope.filterModel[filter].range[0] = scope.defaultFilterModel[filter].range[0],
              scope.filterModel[filter].range[1] = scope.defaultFilterModel[filter].range[1];
            scope.filterModel[filter].pristine = true;
            setSlider();
          } else if (scope.filterModel[filter].type === 'range-date') {
            scope.filterModel[filter].range[0] = null;
            scope.filterModel[filter].range[1] = null;
            scope.filterModel[filter].pristine = true;
          } else {
            scope.filterModel[filter].state = null;
          }
          if (update) {
            scope.updateSelectedFilters();
          }
        };

        scope.clearAllFilters = function () {
          for (var filter in scope.filterModel) {
            scope.removeFilterFromModel(filter, false);
          }
          scope.updateSelectedFilters();
        };

        (function () {
          initiateDropdown();
        })();

        //*****************//
        // INIT
        // ------------------
        // Watches for changes on the scope.filterList for dynamic update of filters
        //*****************//
        scope.$watch(function () {
          return scope.filtersList;
        }, function (newVal, oldVal) {
          if (angular.equals(newVal, oldVal)) {

          } else {
            scope.filtersListOriginal = angular.copy(scope.filtersList);
            initiateDropdown();
            $timeout(function () {
              setEvents();
            }, 100);
          }
        }, true);

        //*****************//
        // INIT and evaluate integrity of stored data and filters
        // ------------------
        // INIT check for async content before calibrationg filterModel
        // Mapping scope.filterList to scope.filterModel (used to pass data around)
        // Mapping scope.filterList to scope.filtersInDropdown (used to render dropdown)
        // Getting storedFilters and evaluate versus scope.filterModel & selectedFilters
        // Configure Slider object
        // Call updateSelectedFilters(); (render, and set params on pagingObject)
        //*****************//
        function initiateDropdown() {
          scope.filtersInDropdown = FilterDropdownService.setPropertiesOnFilterObject(scope.filtersListOriginal);

          calibrateModel();
          // The callback option is not defined when the calibrateModel is initially ran.
          setTimeout(function () {
            setSlider()
          })
        }

        function calibrateModel() {
          scope.filterModel = FilterDropdownService.createFilterModel(scope.filtersListOriginal);
          scope.defaultFilterModel = angular.copy(scope.filterModel);
          resetFilterInStorage();
          evaluateStorageIntegrity();
          evaluateStoredFilterValues();
          var storedFilters = FilterDropdownService.getFiltersFromStorage($location.$$path);
          storedFilters = presetFilters(storedFilters);
          mapStoredFiltersToModel(storedFilters);
          evaluateSelectedFilters();
          setSlider();
          setInput();
          presetRangeDate();
          scope.updateSelectedFilters('init');
        }

        function addDynamicItemsToFilterModel() {
          scope.filterModel = FilterDropdownService.createFilterModel(scope.filtersListOriginal);
          scope.defaultFilterModel = angular.copy(scope.filterModel);
          resetFilterInStorage();
          evaluateStorageIntegrity();
          evaluateStoredFilterValues();
          var storedFilters = FilterDropdownService.getFiltersFromStorage($location.$$path);
          storedFilters = presetFilters(storedFilters);
          mapStoredFiltersToModel(storedFilters);
          evaluateSelectedFilters();
        }

        scope.returnFilterMap = function (filtersInDropdown, index) {
          scope.filtersInDropdown[index].values = filtersInDropdown[index].values;
          addDynamicItemsToFilterModel()
        };

        scope.setPagedFilter = function (filterModel, index) {
          scope.filterModel = filterModel;
          scope.updateSelectedFilters();
        };

        function evaluateStorageIntegrity() {
          FilterDropdownService.evaluateStorageIntegrity($location.$$path, scope.defaultFilterModel);
        }

        function evaluateStoredFilterValues() {
          FilterDropdownService.evaluateStoredFilterValues($location.$$path, scope.defaultFilterModel);
        }

        function resetFilterInStorage() {
          if (scope.resetFilters) {
            FilterDropdownService.setFiltersInStorage($location.$$path, scope.defaultFilterModel);
          }
        }

        function presetFilters(storedFilters) {
          if (scope.presetFilters) {
            for (var i = 0; i < scope.presetFilters.length; i++) {
              storedFilters[scope.presetFilters[i].key] = scope.presetFilters[i];
            }
          }
          return storedFilters;
        }

        function mapStoredFiltersToModel(storedFilters) {
          if (storedFilters) {
            for (var key in storedFilters) {
              scope.filterModel[key] = storedFilters[key];
            }
          }
        }

        function evaluateSelectedFilters() {
          for (var i = 0; i < scope.selectedFilters.length; i++) {
            if (!scope.filterModel.hasOwnProperty(scope.selectedFilters[i].key)) {
              scope.selectedFilters.splice(i, 1);
            }
          }
        }

        function presetRangeDate() {
          for (var key in scope.filterModel) {
            if (scope.filterModel[key].type === 'range-date') {
              var value = scope.filterModel[key].value;
              scope.filterModel[key].range[0] = setDate(value);
              scope.formatedDate = $filter('amDateFormat')(setDate(value), 'DD-MM-YYYY HH:mm:ss');
            }
          }
        }

        function setInput() {
          for (var key in scope.filterModel) {
            if (scope.filterModel[key].type === 'range-input') {
              scope.inputRangeModel.min = scope.filterModel[key].range[0];
              scope.inputRangeModel.max = scope.filterModel[key].range[1];
            }
          }
        }

        function setSlider() {
          for (var key in scope.filterModel) {
            if (scope.filterModel[key].type === 'range') {
              checkSliderOverflow(key);
              scope.sliders[key] = {
                minValue: scope.filterModel[key].pristine ? scope.defaultFilterModel[key].range[0] : scope.filterModel[key].range[0],
                maxValue: scope.filterModel[key].pristine ? scope.defaultFilterModel[key].range[1] : scope.filterModel[key].range[1],
                options: {
                  id: key,
                  floor: scope.defaultFilterModel[key].range[0],
                  ceil: scope.defaultFilterModel[key].range[1],
                  step: 1,
                  onEnd: scope.updateFilterModel // callback(key)
                }
              };
            }
          }
        }

        function checkSliderOverflow(key) {
          var filterMax = scope.filterModel[key].range[1];
          var defaultMax = scope.defaultFilterModel[key].range[1];
          if (filterMax > defaultMax) {
            scope.filterModel[key].range[1] = scope.defaultFilterModel[key].range[1];
          }
        }

        scope.updateFilterModel = function (key) {
          scope.filterModel[key].range[0] = scope.sliders[key].minValue;
          scope.filterModel[key].range[1] = scope.sliders[key].maxValue;
          var filterMin = scope.filterModel[key].range[0];
          var filterMax = scope.filterModel[key].range[1];
          var defaultMin = scope.defaultFilterModel[key].range[0];
          var defaultMax = scope.defaultFilterModel[key].range[1];

          if (defaultMin !== filterMin || defaultMax !== filterMax) {
            scope.filterModel[key].pristine = false;
          } else {
            scope.filterModel[key].pristine = true;
          }

          $timeout(function () {
            scope.updateSelectedFilters();
          }, 500);
        };

        scope.presetRange = function (presetRange, key) {
          switch (presetRange) {
            case 'zero':
              scope.sliders[key].minValue = 0;
              scope.sliders[key].maxValue = 0;
              break;
            case 'zeroToOne':
              scope.sliders[key].minValue = 0;
              scope.sliders[key].maxValue = 1;
              break;
            case 'oneToMax':
              scope.sliders[key].minValue = 1;
              scope.sliders[key].maxValue = scope.defaultFilterModel[key].range[1];
              break;
            case 'minToMax':
              scope.sliders[key].minValue = scope.defaultFilterModel[key].range[0];
              scope.sliders[key].maxValue = scope.defaultFilterModel[key].range[1];
              break;
            case 'input':
              break;
          }
          scope.updateFilterModel(key);
        };

        scope.setRangeInput = function (key) { // REMEMBER TO TEST THIS
          if ((scope.inputRangeModel.min === scope.inputRangeModel.max) || (scope.inputRangeModel.min > scope.inputRangeModel.max)) {
            scope.filterModel[key].pristine = true;
          } else if (scope.inputRangeModel.max > scope.inputRangeModel.min && scope.inputRangeModel.max !== 0) {
            scope.filterModel[key].range[0] = scope.inputRangeModel.min;
            scope.filterModel[key].range[1] = scope.inputRangeModel.max;
            scope.filterModel[key].pristine = false;
          } else {
            scope.filterModel[key].pristine = true;
          }

          $timeout(function () {
            scope.updateSelectedFilters();
          }, 500);
        };

        scope.setRangeDate = function (value, key) {
          if (value) {
            scope.filterModel[key].range[0] = setDate(value);
            scope.filterModel[key].range[1] = null;
            scope.filterModel[key]['value'] = value;
            scope.filterModel[key].pristine = false;
            scope.formatedDate = $filter('amDateFormat')(setDate(value), 'DD-MM-YYYY HH:mm:ss');
          }
          else {
            scope.filterModel[key].pristine = true;
          }
          scope.updateSelectedFilters();
        };

        function setDate(value) {
          if (value) {
            var now = new Date();
            now.setHours(now.getHours() - value);
            return now.toISOString();
          }
        }

        //*****************//
        // DROPDOWN CONTROLS
        // ------------------
        // Calling scope.$broadcast('rzSliderForceRender') workaround for slider-render-error
        //*****************//
        function setEvents() {
          angular.element('.dropdown-submenu a.submenu-link').on('click', function (e) {
            closeAllSubMenus();

            if (this.innerText !== thisSubmenu) {
              angular.element(this).next('div').toggle();
              scope.$broadcast('rzSliderForceRender');
              thisSubmenu = this.innerText;
            } else {
              angular.element(this).blur();
              thisSubmenu = '';
            }

            e.stopPropagation();
            e.preventDefault();
          });

          angular.element('.dropdown-content').on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
          });

          angular.element('.dropdown-label').on('click', function (e) {
            e.stopPropagation();
          });
        }

        function closeAllSubMenus() {
          var subMenu = angular.element('div.dropdown-menu.dropdown-ul');
          angular.element(subMenu).css({ display: 'none' });
        }

        scope.resetDropdown = function () {
          thisSubmenu = '';
          closeAllSubMenus();
        };

        scope.resetFocus = function () {
          var menuElement = angular.element('.dropdown-submenu a.submenu-link');
          angular.forEach(menuElement, function (menu) {
            if (menu.innerHTML === thisSubmenu) {
              setTimeout(function () {
                if (angular.element(menu)) {
                  angular.element(menu).focus();
                }
              }, 50);
            }
          });
        };

        (function () {
          $timeout(function () {
            setEvents();
          });
        }());

      }
    };
  };

  filterDropdown.$inject = ['FilterDropdownService', '$location', 'FilterService', '$filter', '$timeout', 'NetworkListService', '$q', 'NetworkListPaging', 'TenantListService'];

  angular
    .module('printix-admin')
    .directive('filterDropdown', filterDropdown);

})();
